import { __assign, __awaiter, __extends, __generator } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import * as Actions from "../../redux/actions/actions.js";
import { UPDATE_MESSAGE_CENTER, IDS_USER_PROFILE, FETCH_LOAN, DELETE_DEXP_MESSAGE_ENTRY, CREATE_DEXP_MESSAGE_ENTRY } from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacCard, PnmacCardContent, PnmacUIButton, PnmacCheckBox, PnmacCardTitle, PnmacParagraph, PnmacTextInput, PnmacSelect, PnmacRadioButtonGroup, PnmacRadioButton, PnmacRowHeader, PnmacMediaQuery, PnmacMeta, PnmacText, PnmacHtmlToNative } from 'pnmac-universal-components';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import styles from '../../styles/styles.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { isEmptyOrSpaces, isValidatePhoneNumber, checkForAllNumbersAndSpecial, checkForAllNumbersAndSpecialZip, checkForZip, isValidateZipLengthNew, checkForForeignZip, isValidatePhoneNumberLength, isValidateZipLength } from '../../utils.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { textStyle } from "../../v2/theme";
import layout from '../../redux/reducers/reducers.js';
import BannerView from '../../v2/BannerView';
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  return {
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: 500,
      margin: 'auto'
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: 10,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3)
    },
    confirm: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      marginLeft: -10,
      marginBottom: 10
    }
  };
});
function TransitionsModal(_a) {
  var open = _a.open,
    confirm = _a.confirm,
    confirmed = _a.confirmed,
    close = _a.close,
    translations = _a.translations;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description",
    className: classes.modal,
    open: open,
    closeAfterTransition: true,
    BackdropComponent: Backdrop,
    BackdropProps: {
      timeout: 500
    }
  }, /*#__PURE__*/React.createElement(Fade, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.paper
  }, /*#__PURE__*/React.createElement("h2", {
    style: textStyle.defaultTextTitle,
    id: "transition-modal-title"
  }, translations === null || translations === void 0 ? void 0 : translations.TCPAModalPopUpTitle), /*#__PURE__*/React.createElement("p", {
    style: textStyle.defaultTextDescription,
    id: "transition-modal-description"
  }, translations === null || translations === void 0 ? void 0 : translations.TCPAModalPopUpContent1), /*#__PURE__*/React.createElement("div", {
    className: classes.confirm
  }, /*#__PURE__*/React.createElement("div", {
    id: 'chkCommunicationsConsent',
    style: {
      marginRight: 10
    }
  }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
    idTag1: 'chkCommunicationsConsent',
    status: confirmed ? 'checked' : 'unchecked',
    onPress: function () {
      confirm();
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: textStyle.defaultTextDescription
  }, translations === null || translations === void 0 ? void 0 : translations.TCPAModalPopUpContent2)), /*#__PURE__*/React.createElement("div", {
    style: textStyle.defaultTextDescription
  }, translations === null || translations === void 0 ? void 0 : translations.TCPAModalPopUpContent3), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacUIButton, {
    mode: 'contained',
    idTag1: 'btnAgreeOrDisagree',
    style: __assign(__assign({}, styles.accountSettings.button), {
      marginTop: 50
    }),
    onClick: function () {
      close();
    }
  }, confirmed ? "Agree" : "Disagree"))))));
}
var ContactInformation = /** @class */function (_super) {
  __extends(ContactInformation, _super);
  function ContactInformation(props) {
    var _this = _super.call(this, props) || this;
    _this.deleteDEXPMessageEntry = function (badContactType) {
      return __awaiter(_this, void 0, void 0, function () {
        var partitionKey;
        var _this = this;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              partitionKey = this.props.layout.borrowerId + "_" + badContactType;
              return [4 /*yield*/, fetch("api/account/delete_dexp_message?borrowerId=".concat(partitionKey), {
                method: 'DELETE',
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                  "Authorization": "Bearer ".concat(this.props.layout.token)
                }
              }).then(function (res) {
                if (res.status == 200) {
                  _this.props.dispatch({
                    type: DELETE_DEXP_MESSAGE_ENTRY,
                    pennyContentKey: ""
                  });
                }
              })];
            case 1:
              _a.sent();
              return [2 /*return*/];
          }
        });
      });
    };
    _this.createDEXPMessageEntry = function (badContactType) {
      fetch("api/account/create_dexp_message?borrowerId=".concat(_this.props.layout.borrowerId, "&&loanId=").concat(_this.props.layout.selectedLoanNumber, "&&partitionKey=").concat(badContactType), {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        }
      }).then(function (res) {
        if (res.status == 200) {
          _this.props.dispatch({
            type: CREATE_DEXP_MESSAGE_ENTRY,
            pennyContentKey: badContactType
          });
        }
      });
    };
    _this.updateDEXPMessageEntry = function () {
      return __awaiter(_this, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _a = this.props.layout.DEXPMessagePennyContentKey;
              switch (_a) {
                case "BadMailingAddressAndBadPhoneAndBadEmailAddress":
                  return [3 /*break*/, 1];
                case "BadEmailAddressAndBadPhoneNumber":
                  return [3 /*break*/, 3];
                case "BadMailingAddressAndBadEmailAddress":
                  return [3 /*break*/, 5];
                case "BadMailingAddressAndBadPhoneNumber":
                  return [3 /*break*/, 7];
                case "BadEmailAddress":
                  return [3 /*break*/, 9];
                case "BadPhoneNumber":
                  return [3 /*break*/, 12];
                case "BadMailingAddress":
                  return [3 /*break*/, 15];
              }
              return [3 /*break*/, 18];
            case 1:
              //delete the baddexpentry
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadMailingAddressAndBadPhoneAndBadEmailAddress")];
            case 2:
              //delete the baddexpentry
              _b.sent();
              if (!this.state.updateEmailSuccessful && !this.state.updatePhoneNumbersSuccessful && this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadEmailAddressAndBadPhoneNumber");
              } else if (!this.state.updateEmailSuccessful && this.state.updatePhoneNumbersSuccessful && !this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadMailingAddressAndBadEmailAddress");
              } else if (!this.state.updateEmailSuccessful && this.state.updatePhoneNumbersSuccessful && this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadEmailAddress");
              } else if (this.state.updateEmailSuccessful && !this.state.updatePhoneNumbersSuccessful && !this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadMailingAddressAndBadPhoneNumber");
              } else if (this.state.updateEmailSuccessful && !this.state.updatePhoneNumbersSuccessful && this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadPhoneNumber");
              } else if (this.state.updateEmailSuccessful && this.state.updatePhoneNumbersSuccessful && !this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadMailingAddress");
              }
              return [3 /*break*/, 18];
            case 3:
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadEmailAddressAndBadPhoneNumber")];
            case 4:
              _b.sent();
              if (this.state.updateEmailSuccessful && !this.state.updatePhoneNumbersSuccessful) {
                this.createDEXPMessageEntry("BadPhoneNumber");
              } else if (!this.state.updateEmailSuccessful && this.state.updatePhoneNumbersSuccessful) {
                this.createDEXPMessageEntry("BadEmailAddress");
              }
              return [3 /*break*/, 18];
            case 5:
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadMailingAddressAndBadEmailAddress")];
            case 6:
              _b.sent();
              if (this.state.updateEmailSuccessful && !this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadMailingAddress");
              } else if (!this.state.updateEmailSuccessful && this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadEmailAddress");
              }
              return [3 /*break*/, 18];
            case 7:
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadMailingAddressAndBadPhoneNumber")];
            case 8:
              _b.sent();
              if (this.state.updatePhoneNumbersSuccessful && !this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadMailingAddress");
              } else if (!this.state.updatePhoneNumbersSuccessful && this.state.updateMailingAddressSucessful) {
                this.createDEXPMessageEntry("BadPhoneNumber");
              }
              return [3 /*break*/, 18];
            case 9:
              if (!this.state.updateEmailSuccessful) return [3 /*break*/, 11];
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadEmailAddress")];
            case 10:
              _b.sent();
              _b.label = 11;
            case 11:
              return [3 /*break*/, 18];
            case 12:
              if (!this.state.updatePhoneNumbersSuccessful) return [3 /*break*/, 14];
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadPhoneNumber")];
            case 13:
              _b.sent();
              _b.label = 14;
            case 14:
              return [3 /*break*/, 18];
            case 15:
              if (!this.state.updateMailingAddressSucessful) return [3 /*break*/, 17];
              return [4 /*yield*/, this.deleteDEXPMessageEntry("BadMailingAddress")];
            case 16:
              _b.sent();
              _b.label = 17;
            case 17:
              return [3 /*break*/, 18];
            case 18:
              return [2 /*return*/];
          }
        });
      });
    };
    _this.sendCode = function (type) {
      var _a;
      _this.setState({
        invalidEmailCode: false,
        invalidPhoneCode: false
      });
      var p = {
        tfaType: type,
        userEmail: _this.state.emailAddress,
        userCellphone: (_a = _this.state.mobilePhoneNumber) === null || _a === void 0 ? void 0 : _a.replace(/[^0-9]/g, ''),
        userCellphoneTcpa: true,
        leadID: _this.props.layout.userProfile.jornaya_id
      };
      fetch("api/account/register_phone", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify(p)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        var _a;
        if (data.sms_token || data.mfa_device) {
          _this.setState((_a = {}, _a["tokenVerify".concat(type)] = true, _a.loading = false, _a.verificationToken = data.sms_token, _a.emailInputVerificationToken = data.sms_token, _a));
        }
      });
    };
    _this.verifyToken = function (type) {
      var _a, _b, _c, _d;
      var p = {
        tfaType: type,
        userEmail: _this.state.emailAddress,
        userCellphone: _this.state.mobilePhoneNumber,
        userCellphoneTcpa: false,
        verificationToken: type === "sms" ? _this.state.phoneInputVerificationToken : _this.state.emailInputVerificationToken,
        loanId: _this.props.layout.selectedLoanNumber
      };
      var _e = _this.props.layout,
        borrowerId = _e.borrowerId,
        currentLoan = _e.currentLoan;
      var allPhones = ((_a = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
        return s.borrowerId == borrowerId;
      })) === null || _a === void 0 ? void 0 : _a.borrowerPhones) || [];
      if (((_c = (_b = _this.props.layout) === null || _b === void 0 ? void 0 : _b.borrowerContactRules) === null || _c === void 0 ? void 0 : _c.length) == 0) {
        _this.props.getBorrowerContactRules(borrowerId);
      }
      var borrowerRules = (_d = _this.props.layout) === null || _d === void 0 ? void 0 : _d.borrowerContactRules;
      fetch("api/account/verify_token", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: JSON.stringify(p)
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        var _a, _b;
        if (type == "sms" && data.message == "ok" && parseInt(_this.props.layout.selectedLoanNumber) > 0) {
          var allPhonesFormData_1 = _this.buildPhoneObject(allPhones);
          allPhonesFormData_1.forEach(function (s) {
            s.loanId = _this.props.layout.selectedLoanNumber;
            if (s.phoneTypeId == 3) {
              s.confirmedFlag = true;
            }
          });
          fetch("api/account/update_phone_numbers?sendEvent=true", {
            method: 'POST',
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              "Authorization": "Bearer ".concat(_this.props.layout.token)
            },
            body: JSON.stringify(allPhonesFormData_1)
          }).then(function (res) {
            return res.json();
          }).then(function (data) {
            var _a, _b;
            //Once the mobile number is added, we need to update the preference data to LS
            if (borrowerRules && (borrowerRules === null || borrowerRules === void 0 ? void 0 : borrowerRules.length) > 0) {
              var updatedArray = borrowerRules.map(function (item) {
                return _this.updateRuleDataOnMobilePhoneAdd(item, borrowerId);
              });
              if (borrowerId > 0 && updatedArray && (updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.length) > 0) {
                fetch("api/loan/update_borrower_contact_rules?borrowerId=" + borrowerId, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": "Bearer ".concat(_this.props.layout.token)
                  },
                  body: JSON.stringify(updatedArray)
                }).then(function (data) {
                  return data.json();
                }).then(function (response) {
                  var _a;
                  if (response) {
                    _this.props.getBorrowerContactRules(borrowerId);
                  }
                  _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a.updateMainPhones = false, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a.verificationToken = "", _a.phoneInputVerificationToken = "", _a), function () {
                    _this.setState({
                      updatePhoneNumbersSuccessful: true,
                      updatePhoneSuccessful: true
                    });
                  });
                  var loanNumber = _this.props.layout.loanNumbers.map(function (item) {
                    return item.loanId;
                  }).join(",");
                  _this.props.get_user_profile(function () {
                    _this.props.refreshLoanData(loanNumber, function () {
                      _this.setState({
                        tokenVerified: true
                      });
                      _this.setState({
                        loading: false
                      });
                      _this.setState({
                        updatePhoneNumbersSuccessful: true,
                        updatePhoneSuccessful: true
                      });
                    });
                  });
                }).catch(function (e) {
                  var _a;
                  _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a.updateMainPhones = false, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a.verificationToken = "", _a.phoneInputVerificationToken = "", _a));
                  var loanNumber = _this.props.layout.loanNumbers.map(function (item) {
                    return item.loanId;
                  }).join(",");
                  _this.props.get_user_profile(function () {
                    _this.props.refreshLoanData(loanNumber, function () {
                      _this.setState({
                        tokenVerified: true
                      });
                      _this.setState({
                        loading: false
                      });
                      _this.setState({
                        updatePhoneNumbersSuccessful: true,
                        updatePhoneSuccessful: false
                      });
                    });
                  });
                });
              } else {
                _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a.updateMainPhones = false, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a.verificationToken = "", _a.phoneInputVerificationToken = "", _a));
                var loanNumber_1 = _this.props.layout.loanNumbers.map(function (item) {
                  return item.loanId;
                }).join(",");
                _this.props.get_user_profile(function () {
                  _this.props.refreshLoanData(loanNumber_1, function () {
                    _this.setState({
                      tokenVerified: true
                    });
                    _this.setState({
                      loading: false
                    });
                    _this.setState({
                      updatePhoneNumbersSuccessful: true,
                      updatePhoneSuccessful: false
                    });
                  });
                });
              }
            } else {
              _this.setState((_b = {}, _b["tokenVerify".concat(type)] = false, _b["numnberVerfied".concat(type)] = true, _b.updateMainPhones = false, _b["".concat(type, "Verified")] = true, _b["".concat(type, "ConsentMobile")] = false, _b.verificationToken = "", _b.phoneInputVerificationToken = "", _b));
              var loanNumber_2 = _this.props.layout.loanNumbers.map(function (item) {
                return item.loanId;
              }).join(",");
              _this.props.get_user_profile(function () {
                _this.props.refreshLoanData(loanNumber_2, function () {
                  _this.setState({
                    tokenVerified: true
                  });
                  _this.setState({
                    loading: false
                  });
                  _this.setState({
                    updatePhoneNumbersSuccessful: true,
                    updatePhoneSuccessful: false
                  });
                });
              });
            }
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Phone Number Update Successful", 252, JSON.stringify(allPhonesFormData_1));
            _this.updateDEXPMessageEntry();
          });
        } else if (type == "sms") {
          _this.setState({
            invalidPhoneCode: true,
            loading: false
          });
        }
        if (type == "email" && data.message == "ok") {
          //Once the email is updated, we need to update the preference data to LS
          if (borrowerRules && (borrowerRules === null || borrowerRules === void 0 ? void 0 : borrowerRules.length) > 0) {
            var updatedArray = _this.updateRuleDataOnEmailUpdate(borrowerRules, borrowerId);
            if (borrowerId > 0 && updatedArray && (updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.length) > 0) {
              fetch("api/loan/update_borrower_contact_rules?borrowerId=" + borrowerId, {
                method: "POST",
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                  "Authorization": "Bearer ".concat(_this.props.layout.token)
                },
                body: JSON.stringify(updatedArray)
              }).then(function (data) {
                return data.json();
              }).then(function (response) {
                var _a;
                if (response) {
                  _this.props.getBorrowerContactRules(borrowerId);
                }
                _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a));
                var loanNumber = _this.props.layout.loanNumbers.map(function (item) {
                  return item.loanId;
                }).join(",");
                _this.props.get_user_profile(function () {
                  _this.props.refreshLoanData(loanNumber, function () {
                    _this.setState({
                      loading: false,
                      verificationToken: "",
                      emailInputVerificationToken: ""
                    });
                    _this.setState({
                      updateEmailSuccessful: true
                    });
                    _this.updateDEXPMessageEntry();
                  });
                });
              }).catch(function (e) {
                var _a;
                _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a));
                var loanNumber = _this.props.layout.loanNumbers.map(function (item) {
                  return item.loanId;
                }).join(",");
                _this.props.get_user_profile(function () {
                  _this.props.refreshLoanData(loanNumber, function () {
                    _this.setState({
                      loading: false,
                      verificationToken: "",
                      emailInputVerificationToken: ""
                    });
                    _this.setState({
                      updateEmailSuccessful: true
                    });
                    _this.updateDEXPMessageEntry();
                  });
                });
              });
            } else {
              _this.setState((_a = {}, _a["tokenVerify".concat(type)] = false, _a["numnberVerfied".concat(type)] = true, _a["".concat(type, "Verified")] = true, _a["".concat(type, "ConsentMobile")] = false, _a));
              var loanNumber_3 = _this.props.layout.loanNumbers.map(function (item) {
                return item.loanId;
              }).join(",");
              _this.props.get_user_profile(function () {
                _this.props.refreshLoanData(loanNumber_3, function () {
                  _this.setState({
                    loading: false,
                    verificationToken: "",
                    emailInputVerificationToken: ""
                  });
                  _this.setState({
                    updateEmailSuccessful: true
                  });
                  _this.updateDEXPMessageEntry();
                });
              });
            }
          } else {
            _this.setState((_b = {}, _b["tokenVerify".concat(type)] = false, _b["numnberVerfied".concat(type)] = true, _b["".concat(type, "Verified")] = true, _b["".concat(type, "ConsentMobile")] = false, _b));
            var loanNumber_4 = _this.props.layout.loanNumbers.map(function (item) {
              return item.loanId;
            }).join(",");
            _this.props.get_user_profile(function () {
              _this.props.refreshLoanData(loanNumber_4, function () {
                _this.setState({
                  loading: false,
                  verificationToken: "",
                  emailInputVerificationToken: ""
                });
                _this.setState({
                  updateEmailSuccessful: true
                });
                _this.updateDEXPMessageEntry();
              });
            });
          }
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Email Update Successful", 252, JSON.stringify(p.userEmail));
        } else if (type == "email") {
          _this.setState({
            invalidEmailCode: true,
            loading: false
          });
        }
      });
    };
    _this.updateMailingAddress = function (props) {
      var post = JSON.stringify({
        "LoanId": _this.props.layout.selectedLoanNumber,
        "LoanAddressType": 1,
        "Line1": _this.state.mailingForeignAddressFlag ? _this.state.foreignMailingAddress : _this.state.mailingAddress,
        "Locality": _this.state.mailingForeignAddressFlag ? null : _this.state.mailingCity,
        "Region": _this.state.mailingForeignAddressFlag ? null : _this.state.mailingState,
        "PostalCode": _this.state.mailingForeignAddressFlag ? _this.state.foreignMailingZip : _this.state.mailingZip,
        "ValidFlag": true,
        "ForeignAddressFlag": _this.state.mailingForeignAddressFlag,
        "ConfirmedFlag": true,
        "CountryCode": _this.state.mailingForeignAddressFlag ? _this.state.countryCode : "US",
        "Line2": _this.state.mailingForeignAddressFlag ? _this.state.foreignMailingAddress2 : null
      });
      fetch("api/account/update_mailing_address", {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
          "Authorization": "Bearer ".concat(_this.props.layout.token)
        },
        body: post
      }).then(function (res) {
        return res.json();
      }).then(function (data) {
        _this.setState({
          loading: false,
          confirmFinal: true,
          notchanged: true,
          updateMailingAddressSucessful: true
        }, function () {
          _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Mailing Address Update Successful", 252, post);
          _this.updateDEXPMessageEntry();
          if (_this.state.mailingForeignAddressFlag) {
            _this.props.dispatch({
              type: FETCH_LOAN,
              jsData: __assign(__assign({}, _this.props.layout.currentLoan), {
                mailingAddressLine1: _this.state.foreignMailingAddress,
                mailingAddressLine2: _this.state.foreignMailingAddress2,
                mailingPostalCode: _this.state.foreignMailingZip,
                mailingCountryCode: _this.state.countryCode,
                mailingForeignAddressFlag: _this.state.mailingForeignAddressFlag,
                mailingLocality: null,
                mailingRegion: null
              })
            });
          } else {
            _this.props.dispatch({
              type: FETCH_LOAN,
              jsData: __assign(__assign({}, _this.props.layout.currentLoan), {
                mailingAddressLine1: _this.state.mailingAddress,
                mailingLocality: _this.state.mailingCity,
                mailingRegion: _this.state.mailingState,
                mailingPostalCode: _this.state.mailingZip,
                mailingForeignAddressFlag: _this.state.mailingForeignAddressFlag,
                mailingCountryCode: null
              })
            });
          }
        });
      });
    };
    _this.buildPhoneObject = function (allPhones) {
      var _a = _this.state,
        mobilePhoneNumber = _a.mobilePhoneNumber,
        homePhoneNumber = _a.homePhoneNumber,
        workPhoneNumberMobile = _a.workPhoneNumberMobile,
        homePhoneNumberMobile = _a.homePhoneNumberMobile,
        workPhoneNumber = _a.workPhoneNumber;
      var borrowerId = _this.props.layout.borrowerId;
      if (allPhones.find(function (s) {
        return s.phoneTypeId == 1;
      })) {
        var good = homePhoneNumber === null || homePhoneNumber === void 0 ? void 0 : homePhoneNumber.replace(/[^0-9]/g, '');
        allPhones.find(function (s) {
          return s.phoneTypeId == 1;
        }).mobilePhoneFlag = (good === null || good === void 0 ? void 0 : good.length) > 0 ? homePhoneNumberMobile : false;
        allPhones.find(function (s) {
          return s.phoneTypeId == 1;
        }).phoneNumber = homePhoneNumber === null || homePhoneNumber === void 0 ? void 0 : homePhoneNumber.replace(/[^0-9]/g, '');
      } else {
        var good = homePhoneNumber === null || homePhoneNumber === void 0 ? void 0 : homePhoneNumber.replace(/[^0-9]/g, '');
        allPhones.push({
          "phoneId": 0,
          "borrowerId": borrowerId,
          "phoneTypeId": 1,
          "loanId": _this.props.layout.selectedLoanNumber,
          "phoneNumber": homePhoneNumber === null || homePhoneNumber === void 0 ? void 0 : homePhoneNumber.replace(/[^0-9]/g, ''),
          "mobilePhoneFlag": (good === null || good === void 0 ? void 0 : good.length) > 0 ? homePhoneNumberMobile : false,
          "confirmedFlag": false,
          "validFlag": true,
          "tcpaAcceptanceFlag": null,
          "tcpaAcceptanceDate": null,
          "termsOfAcceptanceId": null,
          "createdDate": "2015-06-04T15:47:11.833",
          "createdBy": "PNMAC\\00bpssql",
          "modifiedDate": "2020-10-28T17:51:02",
          "modifiedBy": "PNMAC\\00bpssql",
          "appId": 23
        });
      }
      if (allPhones.find(function (s) {
        return s.phoneTypeId == 2;
      })) {
        var good = workPhoneNumber === null || workPhoneNumber === void 0 ? void 0 : workPhoneNumber.replace(/[^0-9]/g, '');
        allPhones.find(function (s) {
          return s.phoneTypeId == 2;
        }).mobilePhoneFlag = (good === null || good === void 0 ? void 0 : good.length) > 0 ? workPhoneNumberMobile : false;
        allPhones.find(function (s) {
          return s.phoneTypeId == 2;
        }).phoneNumber = workPhoneNumber === null || workPhoneNumber === void 0 ? void 0 : workPhoneNumber.replace(/[^0-9]/g, '');
      } else {
        var good = workPhoneNumber === null || workPhoneNumber === void 0 ? void 0 : workPhoneNumber.replace(/[^0-9]/g, '');
        allPhones.push({
          "phoneId": 0,
          "borrowerId": borrowerId,
          "phoneTypeId": 2,
          "phoneNumber": workPhoneNumber === null || workPhoneNumber === void 0 ? void 0 : workPhoneNumber.replace(/[^0-9]/g, ''),
          "mobilePhoneFlag": (good === null || good === void 0 ? void 0 : good.length) > 0 ? workPhoneNumberMobile : false,
          "confirmedFlag": false,
          "validFlag": true,
          "tcpaAcceptanceFlag": null,
          "tcpaAcceptanceDate": null,
          "termsOfAcceptanceId": null,
          "createdDate": "2015-06-04T15:47:11.833",
          "createdBy": "PNMAC\\00bpssql",
          "modifiedDate": "2020-10-28T17:51:02",
          "modifiedBy": "PNMAC\\00bpssql",
          "appId": 23
        });
      }
      if (allPhones.find(function (s) {
        return s.phoneTypeId == 3;
      })) {
        allPhones.find(function (s) {
          return s.phoneTypeId == 3;
        }).phoneNumber = mobilePhoneNumber === null || mobilePhoneNumber === void 0 ? void 0 : mobilePhoneNumber.replace(/[^0-9]/g, '');
      } else {
        allPhones.push({
          "phoneId": 0,
          "borrowerId": borrowerId,
          "phoneTypeId": 3,
          "phoneNumber": mobilePhoneNumber === null || mobilePhoneNumber === void 0 ? void 0 : mobilePhoneNumber.replace(/[^0-9]/g, ''),
          "mobilePhoneFlag": true,
          "confirmedFlag": false,
          "validFlag": true,
          "tcpaAcceptanceFlag": null,
          "tcpaAcceptanceDate": null,
          "termsOfAcceptanceId": null,
          "createdDate": "2015-06-04T15:47:11.833",
          "createdBy": "PNMAC\\00bpssql",
          "modifiedDate": "2020-10-28T17:51:02",
          "modifiedBy": "PNMAC\\00bpssql",
          "appId": 23
        });
      }
      return allPhones;
    };
    _this.validate = function (place) {
      var _a = _this.state,
        foreignMailingAddress = _a.foreignMailingAddress,
        foreignMailingAddress2 = _a.foreignMailingAddress2,
        foreignMailingZip = _a.foreignMailingZip,
        mailingAddress = _a.mailingAddress,
        mailingCity = _a.mailingCity,
        mailingState = _a.mailingState,
        mailingZip = _a.mailingZip,
        countryCode = _a.countryCode,
        mailingForeignAddressFlag = _a.mailingForeignAddressFlag;
      switch (place) {
        case "address":
          if (!mailingForeignAddressFlag) {
            return !isEmptyOrSpaces(mailingAddress) && !isEmptyOrSpaces(mailingCity) && !isEmptyOrSpaces(mailingState) && !isEmptyOrSpaces(mailingZip) && !isEmptyOrSpaces(mailingState) && checkForZip(mailingZip);
          } else {
            return !isEmptyOrSpaces(foreignMailingAddress) && !isEmptyOrSpaces(foreignMailingAddress2) && !isEmptyOrSpaces(countryCode) && !isEmptyOrSpaces(foreignMailingZip) && !isEmptyOrSpaces(countryCode);
          }
          break;
      }
    };
    _this.validateEmail = function (address) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(address.toLowerCase());
    };
    _this.getPhoneTypeIds = function () {
      var phoneTypes = [];
      var _a = _this.state,
        oldHomePhoneNumber = _a.oldHomePhoneNumber,
        oldHomePhoneNumberMobile = _a.oldHomePhoneNumberMobile,
        oldWorkPhoneNumber = _a.oldWorkPhoneNumber,
        oldWorkPhoneNumberMobile = _a.oldWorkPhoneNumberMobile,
        homePhoneNumber = _a.homePhoneNumber,
        homePhoneNumberMobile = _a.homePhoneNumberMobile,
        workPhoneNumber = _a.workPhoneNumber,
        workPhoneNumberMobile = _a.workPhoneNumberMobile;
      if (oldHomePhoneNumber != null && oldHomePhoneNumber != homePhoneNumber || oldHomePhoneNumberMobile != homePhoneNumberMobile) {
        phoneTypes.push("Home Phone");
      }
      if (oldWorkPhoneNumber != null && oldWorkPhoneNumber != workPhoneNumber || oldWorkPhoneNumberMobile != workPhoneNumberMobile) {
        phoneTypes.push("Work Phone");
      }
      return phoneTypes;
    };
    _this.updateRuleDataOnEmailUpdate = function (borrowerRules, borrowerId) {
      var userOptedInForAnyService = borrowerRules.filter(function (item) {
        return item.emailConsentTypeId === 2;
      });
      if ((userOptedInForAnyService === null || userOptedInForAnyService === void 0 ? void 0 : userOptedInForAnyService.length) > 0) {
        var optedInUpdatedArray = borrowerRules.map(function (item) {
          var tempItem = item;
          //If user is Opted-in for any of services for old email, Opt user in for all 3 (Loanservicing, Digital Alerts and Payment reminder)
          tempItem.emailConsentTypeId = 2;
          tempItem.emailConsentSpecified = true;
          tempItem.borrowerId = borrowerId;
          tempItem.emailConsentDate = moment().format("YYYY-MM-DD");
          return tempItem;
        });
        return optedInUpdatedArray;
      }
      var userOptedOutForLoanService = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 1 && item.emailConsentTypeId === 3;
      });
      var userOptedOutForDigitalAlert = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 2 && item.emailConsentTypeId === 3;
      });
      var userOptedOutForPayment = borrowerRules.filter(function (item) {
        return item.contactRuleScopeId === 3 && item.emailConsentTypeId === 3;
      });
      if ((userOptedOutForLoanService === null || userOptedOutForLoanService === void 0 ? void 0 : userOptedOutForLoanService.length) > 0 && (userOptedOutForDigitalAlert === null || userOptedOutForDigitalAlert === void 0 ? void 0 : userOptedOutForDigitalAlert.length) > 0 && (userOptedOutForPayment === null || userOptedOutForPayment === void 0 ? void 0 : userOptedOutForPayment.length) > 0) {
        var optedOutUpdatedArray = borrowerRules.map(function (item) {
          var tempItem = item;
          //If user is Opted-out for all 3 services for old email, Opt user out for all 3 (Loanservicing, Digital Alerts and Payment reminder)
          tempItem.emailConsentTypeId = 3;
          tempItem.emailConsentSpecified = true;
          tempItem.borrowerId = borrowerId;
          tempItem.emailConsentDate = moment().format("YYYY-MM-DD");
          return tempItem;
        });
        return optedOutUpdatedArray;
      }
    };
    _this.updateRuleDataOnMobilePhoneAdd = function (item, borrowerId) {
      var tempItem = item;
      if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 1) {
        tempItem.textConsentTypeId = 2;
      } else if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 2) {
        tempItem.textConsentTypeId = 2;
      } else if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 3) {
        tempItem.textConsentTypeId = 1;
        if (tempItem.emailConsentTypeId != 2) {
          tempItem.paymentReminderDay = null;
          tempItem.paymentReminderDaySpecified = true;
        }
      }
      tempItem.textConsentSpecified = true;
      tempItem.borrowerId = borrowerId;
      tempItem.textConsentDate = moment().format("YYYY-MM-DD");
      return tempItem;
    };
    _this.updateRuleDataOnMobilePhoneUpdate = function (item, borrowerId) {
      var tempItem = item;
      if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 1 && (item === null || item === void 0 ? void 0 : item.textConsentTypeId) === 2 || (item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 2 && (item === null || item === void 0 ? void 0 : item.textConsentTypeId) === 2) {
        tempItem.textConsentTypeId = 2;
      } else if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 3 && (item === null || item === void 0 ? void 0 : item.textConsentTypeId) === 2) {
        tempItem.textConsentTypeId = 1;
        if (tempItem.emailConsentTypeId != 2) {
          tempItem.paymentReminderDay = null;
          tempItem.paymentReminderDaySpecified = true;
        }
      }
      tempItem.textConsentSpecified = true;
      tempItem.borrowerId = borrowerId;
      tempItem.textConsentDate = moment().format("YYYY-MM-DD");
      return tempItem;
    };
    _this.updateRuleDataOnMobilePhoneDelete = function (item, borrowerId) {
      var tempItem = item;
      if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 1) {
        tempItem.textConsentTypeId = 1;
      } else if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 2) {
        if ((item === null || item === void 0 ? void 0 : item.textConsentTypeId) === 2 && (item === null || item === void 0 ? void 0 : item.emailConsentTypeId) === 1) {
          tempItem.emailConsentTypeId = 2;
          tempItem.emailConsentSpecified = true;
          tempItem.emailConsentDate = moment().format("YYYY-MM-DD");
        }
        tempItem.textConsentTypeId = 1;
      } else if ((item === null || item === void 0 ? void 0 : item.contactRuleScopeId) === 3) {
        if (tempItem.emailConsentTypeId != 2) {
          tempItem.paymentReminderDay = null;
          tempItem.paymentReminderDaySpecified = true;
        }
        tempItem.textConsentTypeId = 1;
      }
      tempItem.textConsentSpecified = true;
      tempItem.borrowerId = borrowerId;
      tempItem.textConsentDate = moment().format("YYYY-MM-DD");
      return tempItem;
    };
    _this.state = {
      emailAddress: _this.props.layout.userProfile.verified_email,
      mobilePhoneNumber: _this.props.layout.userProfile.verified_phone_number,
      homePhoneNumber: null,
      workPhoneNumber: null,
      homePhoneNumberMobile: false,
      workPhoneNumberMobile: false,
      updatePhoneSuccessful: false,
      oldHomePhoneNumber: null,
      oldWorkPhoneNumber: null,
      oldHomePhoneNumberMobile: false,
      oldWorkPhoneNumberMobile: false,
      mailingAddress: "",
      mailingCity: null,
      mailingState: null,
      mailingZip: null,
      mailingStreetAddressError: false,
      mailingCityError: false,
      mailingZipError: false,
      mailingAddressError: false,
      mailingAddress2Error: false,
      mailingStateClicked: false,
      mailingCountryClicked: false,
      foreignMailingAddress: null,
      foreignMailingAddressError: false,
      foreignMailingAddress2: null,
      foreignMailingAddress2Error: false,
      foreignMailingZip: null,
      foreignMailingZipError: false,
      openModal: false,
      smsConsentMobile: false,
      tokenVerifysms: false,
      verificationToken: "",
      emailInputVerificationToken: "",
      phoneInputVerificationToken: "",
      numnberVerfiedsms: false,
      confirmConsentEmail: false,
      tokenVerifyemail: false,
      numnberVerfiedemail: false,
      updateMailingAddress: false,
      confirmFinal: false,
      loading: false,
      notchanged: true,
      updateMainPhones: false,
      mailingForeignAddressFlag: false,
      countryCode: null,
      mailingAddress2: null,
      loadedMount: false,
      countries: [],
      state: [],
      smsVerified: false,
      tokenVerified: false,
      emailVerified: false,
      sideNum: false,
      switched: false,
      changeNumber: false,
      invalidEmailCode: false,
      invalidPhoneCode: false,
      emailAddressError: false,
      updateEmailSuccessful: false,
      updatePhoneNumbersSuccessful: false,
      updateMailingAddressSucessful: false
    };
    return _this;
  }
  ContactInformation.prototype.componentDidMount = function () {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    fetch("api/main/get_mailing_codes", {
      method: 'GET',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        "Authorization": "Bearer ".concat(this.props.layout.token)
      }
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      _this.setState({
        states: data.states,
        countries: data.countries
      });
    });
    this.setState({
      oldHomePhoneNumber: ((_d = (_c = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _a === void 0 ? void 0 : _a.borrowerSummary.find(function (s) {
        return s.borrowerId == (layout === null || layout === void 0 ? void 0 : layout.borrowerId);
      })) === null || _b === void 0 ? void 0 : _b.borrowerPhones) === null || _c === void 0 ? void 0 : _c.find(function (s) {
        return s.phoneTypeId == 1;
      })) === null || _d === void 0 ? void 0 : _d.phoneNumber) || "",
      oldHomePhoneNumberMobile: ((_h = (_g = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _e === void 0 ? void 0 : _e.borrowerSummary.find(function (s) {
        return s.borrowerId == (layout === null || layout === void 0 ? void 0 : layout.borrowerId);
      })) === null || _f === void 0 ? void 0 : _f.borrowerPhones) === null || _g === void 0 ? void 0 : _g.find(function (s) {
        return s.phoneTypeId == 1;
      })) === null || _h === void 0 ? void 0 : _h.mobilePhoneFlag) || false,
      oldWorkPhoneNumber: ((_m = (_l = (_k = (_j = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _j === void 0 ? void 0 : _j.borrowerSummary.find(function (s) {
        return s.borrowerId == (layout === null || layout === void 0 ? void 0 : layout.borrowerId);
      })) === null || _k === void 0 ? void 0 : _k.borrowerPhones) === null || _l === void 0 ? void 0 : _l.find(function (s) {
        return s.phoneTypeId == 2;
      })) === null || _m === void 0 ? void 0 : _m.phoneNumber) || "",
      oldWorkPhoneNumberMobile: ((_r = (_q = (_p = (_o = layout === null || layout === void 0 ? void 0 : layout.currentLoan) === null || _o === void 0 ? void 0 : _o.borrowerSummary.find(function (s) {
        return s.borrowerId == (layout === null || layout === void 0 ? void 0 : layout.borrowerId);
      })) === null || _p === void 0 ? void 0 : _p.borrowerPhones) === null || _q === void 0 ? void 0 : _q.find(function (s) {
        return s.phoneTypeId == 2;
      })) === null || _r === void 0 ? void 0 : _r.mobilePhoneFlag) || false
    });
  };
  ContactInformation.getDerivedStateFromProps = function (newProps, prevState) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _j = (newProps === null || newProps === void 0 ? void 0 : newProps.layout) || {},
      currentLoan = _j.currentLoan,
      borrowerId = _j.borrowerId;
    if ((currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary) && prevState.loadedMount == false) {
      return __assign(__assign({}, prevState), {
        loadedMount: true,
        homePhoneNumber: ((_b = (_a = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
          return s.borrowerId == borrowerId;
        })) === null || _a === void 0 ? void 0 : _a.borrowerPhones.find(function (s) {
          return s.phoneTypeId == 1;
        })) === null || _b === void 0 ? void 0 : _b.phoneNumber) || "",
        homePhoneNumberMobile: ((_d = (_c = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
          return s.borrowerId == borrowerId;
        })) === null || _c === void 0 ? void 0 : _c.borrowerPhones.find(function (s) {
          return s.phoneTypeId == 1;
        })) === null || _d === void 0 ? void 0 : _d.mobilePhoneFlag) || false,
        workPhoneNumber: ((_f = (_e = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
          return s.borrowerId == borrowerId;
        })) === null || _e === void 0 ? void 0 : _e.borrowerPhones.find(function (s) {
          return s.phoneTypeId == 2;
        })) === null || _f === void 0 ? void 0 : _f.phoneNumber) || "",
        workPhoneNumberMobile: ((_h = (_g = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
          return s.borrowerId == borrowerId;
        })) === null || _g === void 0 ? void 0 : _g.borrowerPhones.find(function (s) {
          return s.phoneTypeId == 2;
        })) === null || _h === void 0 ? void 0 : _h.mobilePhoneFlag) || false,
        mailingAddress: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) ? "" : (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingAddressLine1) || "",
        mailingCity: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingLocality) || "",
        mailingState: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingRegion) || '',
        mailingZip: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) ? "" : (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingPostalCode) || "",
        mailingForeignAddressFlag: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) || false,
        countryCode: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingCountryCode) || null,
        foreignMailingAddress: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) ? (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingAddressLine1) || "" : "",
        foreignMailingAddress2: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) ? (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingAddressLine2) || "" : "",
        foreignMailingZip: (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingForeignAddressFlag) ? (currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.mailingPostalCode) || "" : ""
      });
    }
    return null;
  };
  ContactInformation.prototype.render = function () {
    var _this = this;
    var _a, _b, _c, _d, _e;
    var _f = this.state,
      emailAddress = _f.emailAddress,
      mobilePhoneNumber = _f.mobilePhoneNumber,
      homePhoneNumber = _f.homePhoneNumber,
      workPhoneNumber = _f.workPhoneNumber,
      homePhoneNumberMobile = _f.homePhoneNumberMobile,
      workPhoneNumberMobile = _f.workPhoneNumberMobile,
      mailingAddress = _f.mailingAddress,
      mailingCity = _f.mailingCity,
      mailingState = _f.mailingState,
      mailingZip = _f.mailingZip,
      mailingStreetAddressError = _f.mailingStreetAddressError,
      mailingCityError = _f.mailingCityError,
      mailingZipError = _f.mailingZipError,
      mailingAddressError = _f.mailingAddressError,
      mailingAddress2Error = _f.mailingAddress2Error,
      mailingStateClicked = _f.mailingStateClicked,
      mailingCountryClicked = _f.mailingCountryClicked,
      foreignMailingAddress = _f.foreignMailingAddress,
      foreignMailingAddress2 = _f.foreignMailingAddress2,
      foreignMailingAddressError = _f.foreignMailingAddressError,
      dropDownMailingCountryError = _f.dropDownMailingCountryError,
      dropDownMailingStateError = _f.dropDownMailingStateError,
      foreignMailingAddress2Error = _f.foreignMailingAddress2Error,
      foreignMailingZip = _f.foreignMailingZip,
      foreignMailingZipError = _f.foreignMailingZipError,
      smsVerified = _f.smsVerified,
      openModal = _f.openModal,
      tokenVerifyemail = _f.tokenVerifyemail,
      smsConsentMobile = _f.smsConsentMobile,
      tokenVerifysms = _f.tokenVerifysms,
      verificationToken = _f.verificationToken,
      emailInputVerificationToken = _f.emailInputVerificationToken,
      phoneInputVerificationToken = _f.phoneInputVerificationToken,
      numnberVerfiedsms = _f.numnberVerfiedsms,
      emailConsentMobile = _f.emailConsentMobile,
      numnberVerfiedemail = _f.numnberVerfiedemail,
      updateMailingAddress = _f.updateMailingAddress,
      loading = _f.loading,
      confirmFinal = _f.confirmFinal,
      updateMainPhones = _f.updateMainPhones,
      mailingForeignAddressFlag = _f.mailingForeignAddressFlag,
      states = _f.states,
      countries = _f.countries,
      countryCode = _f.countryCode,
      loadedMount = _f.loadedMount,
      emailVerified = _f.emailVerified,
      changeNumber = _f.changeNumber,
      emailAddressError = _f.emailAddressError;
    var _g = this.props,
      layout = _g.layout,
      translations = _g.translations;
    var currentLoan = layout.currentLoan,
      borrowerId = layout.borrowerId,
      customerPreference = layout.customerPreference;
    var allPhones = ((_a = currentLoan === null || currentLoan === void 0 ? void 0 : currentLoan.borrowerSummary.find(function (s) {
      return s.borrowerId == borrowerId;
    })) === null || _a === void 0 ? void 0 : _a.borrowerPhones) || [];
    var selectedtfaType = this.props.layout.userProfile.selected_tfa_type;
    var primaryPhoneNumber = ((_c = (_b = allPhones === null || allPhones === void 0 ? void 0 : allPhones.find(function (s) {
      return s.tcpaAcceptanceFlag == true;
    })) === null || _b === void 0 ? void 0 : _b.phoneNumber) === null || _c === void 0 ? void 0 : _c.toString()) || "-";
    var mobileUpdateBanner = (_d = translations.TFAMobilePhoneNumberUpdated) === null || _d === void 0 ? void 0 : _d.replace("[XXX-XXX-XXXX]", primaryPhoneNumber);
    var numberUpdated = (_e = translations === null || translations === void 0 ? void 0 : translations.OptInOut_MessagePhoneUpdate) === null || _e === void 0 ? void 0 : _e.replace("{0}", "phone number");
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Contact Information"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          width: "100%",
          margin: "auto"
        }
      }, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: __assign({}, styles.accountSettings.titleContainer),
        item: translations.contactInformation
      }), /*#__PURE__*/React.createElement(TransitionsModal, {
        sideNum: _this.state.sideNum,
        close: function () {
          return _this.setState({
            openModal: false
          });
        },
        confirm: function () {
          return _this.setState({
            smsConsentMobile: !smsConsentMobile
          });
        },
        confirmed: smsConsentMobile,
        open: openModal,
        translations: translations
      }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacCard, {
        elevation: 0,
        style: {
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          borderColor: "#efefef",
          padding: 25,
          borderBottom: "1px solid #e9e9e9",
          borderRadius: 0
        }
      }, emailVerified ? selectedtfaType == "email" ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: 10,
          margin: 25
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        onClick: function () {
          _this.setState({
            emailVerified: false
          });
        },
        navigation: _this.props.navigation,
        value: translations.TFAEmailUpdatedSuccessfully
      }))) : /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            emailVerified: false
          });
        },
        message: translations.EmailUpdatedSuccessfully
      }) : null, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        key: 0,
        titleStyle: textStyle.defaultTextTitle,
        title: "Email"
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        key: 1
      }, _this.state.emailAddress && _this.state.emailAddress != "" ? null : /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.OptInOut_AddOrRenterEmail)), tokenVerifyemail ? _this.state.invalidEmailCode ? /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red'
        }
      }, translations.ConfirmationCodeIncorrect) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.ConfirmEmailValidMessage), /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.BeginningWith, " ", "PM-".concat(verificationToken === null || verificationToken === void 0 ? void 0 : verificationToken.substring(0, 3)))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 4,
          maxWidth: "80%"
        }
      }, tokenVerifyemail ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Verify Token EmailAddress",
        idTag1: 'txtVerifyTokenforEmailAddress',
        style: {
          margin: 20,
          width: '100%'
        },
        value: "PM-".concat(emailInputVerificationToken),
        mode: "outlined",
        error: _this.state.invalidEmailCode,
        label: 'Verification Token',
        onChangeText: function (verificationToken) {
          _this.setState({
            emailInputVerificationToken: verificationToken.replace("PM-", "")
          });
        }
      })) : /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "EmailAddress",
        idTag1: 'txtEmailAddress',
        style: {
          margin: 20,
          width: '100%'
        },
        value: emailAddress,
        mode: "outlined",
        label: emailAddressError ? "Please enter a valid e-mail address" : "".concat(translations.EmailAddress, " ").concat(numnberVerfiedemail ? "Verified" : ""),
        error: emailAddressError,
        onChangeText: function (emailAddress) {
          _this.setState({
            emailAddress: emailAddress,
            emailConsentMobile: true
          });
        },
        onBlur: function () {
          if (_this.validateEmail(emailAddress)) {
            _this.setState({
              emailAddressError: false
            });
          } else {
            _this.setState({
              emailAddressError: true
            });
          }
        }
      })), emailConsentMobile ? /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnVerifyOrUpdateEmail',
        style: __assign(__assign({}, styles.accountSettings.button), {
          marginLeft: 50
        }),
        loading: loading,
        onClick: function () {
          _this.setState({
            loading: true
          }, function () {
            if (tokenVerifyemail) {
              _this.verifyToken("email");
            } else {
              _this.sendCode("email");
            }
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Update Email in Contact Information Button Clicked", 579);
          });
        }
      }, tokenVerifyemail ? "Verify Email" : "Update Email"), tokenVerifyemail ? /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        style: {
          alignSelf: "flex-end",
          marginBottom: 20,
          marginTop: 20,
          width: "84%"
        },
        onClick: function () {
          _this.setState({
            loading: true
          }, function () {
            _this.sendCode("email");
          });
        }
      }, "Resend Code") : null) : null), /*#__PURE__*/React.createElement("div", {
        className: 'htmlToNative',
        dangerouslySetInnerHTML: {
          __html: translations.EmailToCommunicateMessage
        }
      })))), /*#__PURE__*/React.createElement(PnmacCard, {
        elvation: 0,
        style: {
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          borderBottom: "1px solid #e9e9e9",
          borderColor: "#efefef",
          padding: 20,
          borderRadius: 0
        }
      }, smsVerified && _this.state.tokenVerified && selectedtfaType == "sms" ? /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginBottom: 10,
          margin: 25
        }
      }, /*#__PURE__*/React.createElement(PnmacHtmlToNative, __assign({}, _this.props, {
        onClick: function () {
          _this.setState({
            tokenVerified: false
          });
          _this.setState({
            smsVerified: false
          });
        },
        navigation: _this.props.navigation,
        value: mobileUpdateBanner
      }))) : null, _this.state.updatePhoneSuccessful ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            smsVerified: false
          });
        },
        message: numberUpdated
      }) : null, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        key: 0,
        titleStyle: textStyle.defaultTextTitle,
        title: "Phone"
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        key: 1
      }, tokenVerifysms ? _this.state.invalidPhoneCode ? /*#__PURE__*/React.createElement("div", {
        style: {
          color: 'red'
        }
      }, translations.TextMessageSMSConfirmationCodeInvalid) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, "".concat(translations.AText, " ").concat(translations.TextMessageConfirmationCode, " ").concat(translations.MobileConfirmPhoneNumberValid))) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.defaultTextTitle, {
          marginTop: 15,
          marginLeft: 20
        }]
      }, translations.MobileNumber), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 4,
          maxWidth: "80%"
        }
      }, tokenVerifysms ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Verify Token",
        idTag1: 'txtVerifyToken',
        style: {
          margin: 20,
          width: '100%'
        },
        value: phoneInputVerificationToken,
        mode: "outlined",
        error: _this.state.invalidPhoneCode,
        label: 'Verification Token',
        onChangeText: function (verificationToken) {
          _this.setState({
            phoneInputVerificationToken: verificationToken
          });
        }
      })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mobile PhoneNumber",
        idTag1: 'txtMobilePhoneNumber',
        style: {
          margin: 20,
          width: '100%'
        },
        value: mobilePhoneNumber,
        mode: "outlined",
        label: "".concat(translations.MobilePhoneNumber, " ").concat(numnberVerfiedsms ? "Verified" : ""),
        onChangeText: function (mobilePhoneNumber) {
          _this.setState({
            updatePhoneSuccessful: false
          });
          if (isValidatePhoneNumberLength(mobilePhoneNumber)) {
            _this.setState({
              mobilePhoneNumber: mobilePhoneNumber
            }, function () {
              if (isValidatePhoneNumber(mobilePhoneNumber)) {
                _this.setState({
                  openModal: true
                });
              } else if (mobilePhoneNumber == "") {
                _this.setState({
                  changeNumber: true
                });
              }
            });
          }
        }
      }))), smsConsentMobile && !_this.state.sideNum ? /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          paddingTop: 20
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnVerifyTokenOrSendCode',
        style: __assign(__assign({}, styles.accountSettings.button), {
          marginLeft: 50
        }),
        loading: loading,
        onClick: function () {
          _this.setState({
            loading: true,
            changeNumber: false
          }, function () {
            if (tokenVerifysms) {
              _this.verifyToken("sms");
            } else {
              _this.sendCode("sms");
            }
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Update Phone in Contact Information Button Clicked", 250);
          });
        }
      }, tokenVerifysms ? "Confirm Code" : "Send Code"), tokenVerifysms ? /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        style: {
          alignSelf: "flex-end",
          marginBottom: 20,
          marginTop: 20,
          width: "84%"
        },
        onClick: function () {
          _this.setState({
            loading: true,
            changeNumber: false
          }, function () {
            _this.sendCode("sms");
          });
        }
      }, "Resend Code") : null) : changeNumber ? /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 1
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        nativeID: "btnVerifyTokenOrSendCode",
        style: __assign(__assign({}, styles.accountSettings.button), {
          marginLeft: 50
        }),
        loading: loading,
        onClick: function () {
          _this.setState({
            loading: true
          }, function () {
            fetch("api/account/delete_phone", {
              method: 'GET',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              }
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              if (data) {
                allPhones.forEach(function (s) {
                  return s.loanId = _this.props.layout.selectedLoanNumber;
                });
                fetch("api/account/update_phone_numbers?sendEvent=false", {
                  method: 'POST',
                  headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Authorization": "Bearer ".concat(_this.props.layout.token)
                  },
                  body: JSON.stringify(_this.buildPhoneObject(allPhones))
                }).then(function (res) {
                  return res.json();
                }).then(function (data2) {
                  var _a, _b;
                  if (data2) {
                    //Once the mobile number is deleted, we need to update the preference data to LS
                    var borrowerId_1 = parseInt(layout.borrowerId);
                    if (((_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.borrowerContactRules) === null || _b === void 0 ? void 0 : _b.length) == 0) {
                      _this.props.getBorrowerContactRules(borrowerId_1);
                    }
                    var borrowerRules = layout === null || layout === void 0 ? void 0 : layout.borrowerContactRules;
                    if (borrowerRules && borrowerRules.length > 0) {
                      var updatedArray = borrowerRules.map(function (item) {
                        return _this.updateRuleDataOnMobilePhoneDelete(item, borrowerId_1);
                      });
                      if (borrowerId_1 > 0 && updatedArray && (updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.length) > 0) {
                        fetch("api/loan/update_borrower_contact_rules?borrowerId=" + borrowerId_1, {
                          method: "POST",
                          headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            "Authorization": "Bearer ".concat(_this.props.layout.token)
                          },
                          body: JSON.stringify(updatedArray)
                        }).then(function (data) {
                          return data.json();
                        }).then(function (response) {
                          if (response) {
                            _this.props.getBorrowerContactRules(borrowerId_1);
                          }
                        }).catch(function (e) {});
                      }
                    }
                    _this.setState({
                      loading: false,
                      changeNumber: false
                    }, function () {
                      _this.props.get_user_profile();
                      _this.setState({
                        updatePhoneNumbersSuccessful: true,
                        updatePhoneSuccessful: true
                      });
                      _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Phone Number Update Successful", 252, JSON.stringify(allPhones));
                      _this.updateDEXPMessageEntry();
                    });
                  }
                });
              }
            });
          });
        }
      }, "Delete")) : null), /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.defaultTextTitle, {
          marginLeft: 20
        }]
      }, translations.HomeNumber), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: matches.small || matches.medium ? "column" : "row",
          alignItems: matches.small || matches.medium ? "flex-start" : "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Home PhoneNumber",
        idTag1: 'txtHomePhoneNumber',
        style: {
          margin: 20,
          width: '80%'
        },
        value: homePhoneNumber,
        mode: "outlined",
        label: translations.homeNumber || "Home Number",
        onChangeText: function (homePhoneNumber) {
          _this.setState({
            updatePhoneSuccessful: false
          });
          if (isValidatePhoneNumberLength(homePhoneNumber)) {
            _this.setState({
              homePhoneNumber: homePhoneNumber,
              updateMainPhones: true
            });
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          width: 'auto',
          alignItems: "center",
          display: "flex",
          flexDirection: matches.small || matches.medium ? "row" : "column",
          marginLeft: matches.small || matches.medium ? 20 : 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          fontSize: matches.small ? 14 : 16
        })
      }, translations.MobileDevice), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
        onValueChange: function (value) {
          if (homePhoneNumber) {
            _this.setState({
              updatePhoneSuccessful: false,
              homePhoneNumberMobile: value == "yes" ? true : false,
              updateMainPhones: true,
              openModal: value == "yes" ? true : false,
              sideNum: true
            });
          }
        },
        value: isEmptyOrSpaces(homePhoneNumber) ? null : homePhoneNumberMobile ? "yes" : "no"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "10%",
          marginLeft: matches.small || matches.medium ? 10 : 0,
          display: "flex",
          flexDirection: "row"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          fontSize: 12
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.yes), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: "rdbHomePhoneNumberMobileYes",
        value: "yes"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.no), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: "rdbHomePhoneNumberMobileNo",
        value: "no"
      }))))))), /*#__PURE__*/React.createElement(PnmacText, {
        style: [textStyle.defaultTextTitle, {
          marginLeft: 20
        }]
      }, translations.WorkNumber), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: matches.small || matches.medium ? "column" : "row",
          alignItems: matches.small || matches.medium ? "flex-start" : "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Work PhoneNumber",
        idTag1: 'txtWorkPhoneNumber',
        style: {
          margin: 20,
          width: '80%'
        },
        value: workPhoneNumber,
        mode: "outlined",
        label: translations.WorkNumber,
        onChangeText: function (workPhoneNumber) {
          _this.setState({
            updatePhoneSuccessful: false
          });
          if (isValidatePhoneNumberLength(workPhoneNumber)) {
            _this.setState({
              workPhoneNumber: workPhoneNumber,
              updateMainPhones: true
            });
          }
        }
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          width: 'auto',
          alignItems: "center",
          display: "flex",
          flexDirection: matches.small || matches.medium ? "row" : "column",
          marginLeft: matches.small || matches.medium ? 20 : 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          fontSize: matches.small ? 14 : 16
        })
      }, translations.MobileDevice), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PnmacRadioButtonGroup, {
        onValueChange: function (value) {
          if (workPhoneNumber) {
            _this.setState({
              updatePhoneSuccessful: false,
              workPhoneNumberMobile: value == "yes" ? true : false,
              updateMainPhones: true,
              openModal: value == "yes" ? true : false,
              sideNum: true
            });
          }
        },
        value: isEmptyOrSpaces(workPhoneNumber) ? null : workPhoneNumberMobile ? "yes" : "no"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          width: "10%",
          marginLeft: matches.small || matches.medium ? 10 : 0,
          display: "flex",
          flexDirection: "row"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.yes), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbWorkPhoneNumberMobileYes',
        value: "yes"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: textStyle.defaultTextDescription
      }, translations.no), /*#__PURE__*/React.createElement(PnmacRadioButton, {
        idTag1: 'rdbWorkPhoneNumberMobileNo',
        value: "no"
      })))))))), _this.state.mobilePhoneNumber && _this.state.mobilePhoneNumber != "" ? null : /*#__PURE__*/React.createElement(BannerView, {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement(BannerView.Text, null, translations === null || translations === void 0 ? void 0 : translations.OptInOut_AddOrRenterMobile)), updateMainPhones ? /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center'
        }
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnUpdatePhoneNumbers',
        loading: loading,
        style: __assign(__assign({}, styles.accountSettings.button), {
          width: "40%"
        }),
        onClick: function () {
          if (parseInt(_this.props.layout.selectedLoanNumber) > 0) {
            _this.setState({
              loading: true
            });
            allPhones.forEach(function (s) {
              return s.loanId = _this.props.layout.selectedLoanNumber;
            });
            var all_1 = _this.buildPhoneObject(allPhones);
            fetch("api/account/update_phone_numbers?sendEvent=false", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(all_1)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              var _a, _b, _c, _d;
              //Once the mobile number is updated, we need to update the preference data to LS
              var borrowerId = parseInt(layout.borrowerId);
              if (((_b = (_a = _this.props.layout) === null || _a === void 0 ? void 0 : _a.borrowerContactRules) === null || _b === void 0 ? void 0 : _b.length) == 0) {
                _this.props.getBorrowerContactRules(borrowerId);
              }
              var borrowerRules = layout === null || layout === void 0 ? void 0 : layout.borrowerContactRules;
              if (borrowerRules && (borrowerRules === null || borrowerRules === void 0 ? void 0 : borrowerRules.length) > 0) {
                var updatedArray = borrowerRules.map(function (item) {
                  return _this.updateRuleDataOnMobilePhoneUpdate(item, borrowerId);
                });
                if (borrowerId > 0 && updatedArray && (updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.length) > 0) {
                  fetch("api/loan/update_borrower_contact_rules?borrowerId=" + borrowerId, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json; charset=utf-8",
                      "Authorization": "Bearer ".concat(_this.props.layout.token)
                    },
                    body: JSON.stringify(updatedArray)
                  }).then(function (data) {
                    return data.json();
                  }).then(function (response) {
                    if (response) {
                      _this.props.getBorrowerContactRules(borrowerId);
                    }
                  }).catch(function (e) {});
                }
              }
              _this.setState({
                updateMainPhones: false,
                loading: false,
                smsVerified: true,
                tokenVerified: false,
                homePhoneNumberMobile: ((_c = all_1 === null || all_1 === void 0 ? void 0 : all_1.find(function (s) {
                  return s.phoneTypeId == 1;
                })) === null || _c === void 0 ? void 0 : _c.mobilePhoneFlag) || false,
                workPhoneNumberMobile: ((_d = all_1 === null || all_1 === void 0 ? void 0 : all_1.find(function (s) {
                  return s.phoneTypeId == 2;
                })) === null || _d === void 0 ? void 0 : _d.mobilePhoneFlag) || false
              }, function () {
                setTimeout(function () {
                  _this.setState({
                    oldHomePhoneNumber: homePhoneNumber,
                    oldWorkPhoneNumber: workPhoneNumber,
                    oldHomePhoneNumberMobile: homePhoneNumberMobile,
                    oldWorkPhoneNumberMobile: workPhoneNumberMobile,
                    updatePhoneSuccessful: false
                  });
                }, 2500);
              });
              _this.setState({
                updatePhoneNumbersSuccessful: true,
                updatePhoneSuccessful: true
              });
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Phone Number Update Successful", 252, JSON.stringify(all_1));
              _this.updateDEXPMessageEntry();
            });
          }
        }
      }, "Update Phone Numbers")) : null)), /*#__PURE__*/React.createElement(PnmacCard, {
        elvation: 0,
        style: {
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          borderColor: "#efefef",
          padding: 20,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.MailingAddressUpdated
      }) : null, /*#__PURE__*/React.createElement(PnmacCardTitle, {
        key: 0,
        titleStyle: textStyle.defaultTextTitle,
        title: "".concat(translations.MailingAddressForLoan, " ").concat(layout.selectedLoanNumber)
      }), /*#__PURE__*/React.createElement(PnmacCardContent, {
        key: 1,
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start"
        }
      }, /*#__PURE__*/React.createElement("div", {
        id: 'chkDivMailingAddressSwitch',
        style: {
          display: "flex",
          alignItems: "center"
        }
      }, /*#__PURE__*/React.createElement(PnmacCheckBox, {
        idTag1: "chkMailingAddressSwitch",
        onPress: function () {
          _this.setState({
            mailingForeignAddressFlag: !_this.state.mailingForeignAddressFlag
          });
        },
        status: _this.state.mailingForeignAddressFlag ? 'checked' : 'unchecked'
      }), /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, "This is not a U.S Domestic address")), !mailingForeignAddressFlag ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing Address"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing Address",
        key: 11,
        idTag1: 'txtMailingAddress',
        value: mailingAddress,
        error: mailingStreetAddressError,
        mode: "outlined",
        label: mailingStreetAddressError ? "Please enter a valid mailing street address" : translations.MailingStreetAddress,
        onChangeText: function (mailingAddress) {
          return _this.setState({
            mailingAddress: mailingAddress,
            updateMailingAddress: true
          });
        },
        onBlur: function () {
          if (isEmptyOrSpaces(mailingAddress)) {
            _this.setState({
              mailingStreetAddressError: true
            });
          } else {
            _this.setState({
              mailingStreetAddressError: false
            });
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing City"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing City",
        key: 12,
        idTag1: 'txtMailingCity',
        value: mailingCity,
        error: _this.state.mailingCityError,
        mode: "outlined",
        label: _this.state.mailingCityError ? "Please enter a valid mailing city" : translations.MailingCity,
        onChangeText: function (mailingCity) {
          return _this.setState({
            mailingCity: mailingCity,
            updateMailingAddress: true
          });
        },
        onBlur: function () {
          if (isEmptyOrSpaces(mailingCity)) {
            _this.setState({
              mailingCityError: true
            });
          } else {
            _this.setState({
              mailingCityError: false
            });
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 20,
          marginTop: 16,
          marginBottom: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, dropDownMailingStateError ? /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'rgb(176, 0, 32)'
        }
      }, "Please enter a ", translations.MailingState) : translations.MailingState), /*#__PURE__*/React.createElement(PnmacSelect, {
        accessibilityLabel: "Mailing State",
        idTag1: 'dropDownMailingState',
        style: {
          inputAndroid: dropDownMailingStateError ? {
            border: "1px solid rgb(176 0 32)",
            color: "rgb(176 0 32)"
          } : {}
        },
        onValueChange: function (value) {
          if ("Select an item..." != value) {
            _this.setState({
              mailingState: value,
              updateMailingAddress: true,
              mailingStateClicked: true
            });
          }
        },
        value: mailingState,
        items: (states === null || states === void 0 ? void 0 : states.map(function (s) {
          return {
            label: s.name,
            value: s.id
          };
        })) || [{
          label: "",
          value: ""
        }],
        customStyles: {
          fontSize: 16,
          width: 50,
          paddingHorizontal: 10,
          paddingVertical: 8,
          borderWidth: 1,
          border: "1px solid rgb(176 0 32)",
          borderRadius: 8,
          color: 'black',
          paddingRight: 30
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing Zip"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing Zip",
        key: 13,
        idTag1: 'txtMailingZip',
        value: mailingZip,
        error: mailingZipError,
        mode: "outlined",
        label: mailingZipError ? "Please enter a valid ZIP code" : translations.MailingZIP,
        onChangeText: function (mailingZip) {
          if (checkForAllNumbersAndSpecialZip(mailingZip, '-') && isValidateZipLengthNew(mailingZip)) {
            _this.setState({
              mailingZip: mailingZip,
              updateMailingAddress: true
            });
          }
        },
        onBlur: function () {
          if (!checkForZip(mailingZip)) {
            _this.setState({
              mailingZipError: true
            });
          } else if (isEmptyOrSpaces(mailingZip) || !isValidateZipLengthNew(mailingZip)) {
            _this.setState({
              mailingZipError: true
            });
          } else {
            _this.setState({
              mailingZipError: false
            });
          }
        }
      }))) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing Address1"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing Address1",
        key: 14,
        idTag1: 'txtMailingAddress1',
        value: foreignMailingAddress,
        error: foreignMailingAddressError,
        mode: "outlined",
        label: foreignMailingAddressError ? "Please enter a valid address" : "Address Line 1",
        onChangeText: function (foreignMailingAddress) {
          return _this.setState({
            foreignMailingAddress: foreignMailingAddress,
            updateMailingAddress: true
          });
        },
        onBlur: function () {
          if (isEmptyOrSpaces(foreignMailingAddress)) {
            _this.setState({
              foreignMailingAddressError: true
            });
          } else {
            _this.setState({
              foreignMailingAddressError: false
            });
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing Address2"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing Address2",
        key: 15,
        idTag1: 'txtMailingAddress2',
        value: foreignMailingAddress2,
        error: foreignMailingAddress2Error,
        mode: "outlined",
        label: foreignMailingAddress2Error ? "Please enter a valid address" : "Address Line 2",
        onChangeText: function (foreignMailingAddress2) {
          return _this.setState({
            foreignMailingAddress2: foreignMailingAddress2,
            updateMailingAddress: true
          });
        },
        onBlur: function () {
          if (isEmptyOrSpaces(foreignMailingAddress2)) {
            _this.setState({
              foreignMailingAddress2Error: true
            });
          } else {
            _this.setState({
              foreignMailingAddress2Error: false
            });
          }
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginLeft: 20,
          marginTop: 16,
          marginBottom: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement(PnmacParagraph, {
        style: textStyle.defaultTextDescription
      }, dropDownMailingCountryError ? /*#__PURE__*/React.createElement("span", {
        style: {
          color: 'rgb(176, 0, 32)'
        }
      }, "Please enter a Mailing Country") : "Mailing Country"), /*#__PURE__*/React.createElement(PnmacSelect, {
        accessibilityLabel: "Mailing Country",
        idTag1: 'dropDownMailingCountry',
        style: {
          inputAndroid: dropDownMailingCountryError ? {
            border: "1px solid rgb(176 0 32)",
            color: "rgb(176 0 32)"
          } : {}
        },
        onValueChange: function (value) {
          if ("Select an item..." != value) {
            _this.setState({
              countryCode: value,
              updateMailingAddress: true
            });
          }
        },
        value: countryCode,
        items: (countries === null || countries === void 0 ? void 0 : countries.map(function (s) {
          return {
            label: s.name,
            value: s.id
          };
        })) || [{
          value: "",
          label: ""
        }],
        customStyles: {
          fontSize: 16,
          width: 50,
          paddingHorizontal: 10,
          paddingVertical: 8,
          borderWidth: 1,
          borderColor: '#595959',
          borderRadius: 8,
          color: 'black',
          paddingRight: 30
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          margin: 20,
          width: '80%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: __assign({}, textStyle.defaultTextDescription)
      }, "Mailing Zip"), /*#__PURE__*/React.createElement(PnmacTextInput, {
        textAlign: 'left',
        accessibilityLabel: "Mailing Zip",
        key: 16,
        idTag1: 'txtMailingZip',
        value: foreignMailingZip,
        error: foreignMailingZipError,
        mode: "outlined",
        label: foreignMailingZipError ? "Please enter a valid postal code" : translations.PostalCode,
        onChangeText: function (foreignMailingZip) {
          if (checkForAllNumbersAndSpecialZip(foreignMailingZip, '-a-zA-Z') && isValidateZipLengthNew(foreignMailingZip)) {
            _this.setState({
              foreignMailingZip: foreignMailingZip,
              updateMailingAddress: true
            });
          }
        },
        onBlur: function () {
          if (!checkForForeignZip(foreignMailingZip)) {
            _this.setState({
              foreignMailingZipError: true
            });
          } else if (isEmptyOrSpaces(foreignMailingZip) || !isValidateZipLengthNew(foreignMailingZip)) {
            _this.setState({
              foreignMailingZipError: true
            });
          } else {
            _this.setState({
              foreignMailingZipError: false
            });
          }
        }
      }))), updateMailingAddress ? /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnUpdateMailingAddress',
        style: __assign(__assign({}, styles.accountSettings.button), {
          margin: 20,
          width: "80%"
        }),
        loading: loading,
        onClick: function () {
          if (_this.validate("address")) {
            _this.setState({
              loading: true
            }, function () {
              _this.updateMailingAddress();
              _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Update Mailing Address in Contact Information Button Clicked", 576);
            });
          } else {
            _this.state.mailingForeignAddressFlag ? _this.setState({
              foreignMailingStreetAddressError2: isEmptyOrSpaces(foreignMailingAddress),
              foreignMailingAddress2Error: isEmptyOrSpaces(foreignMailingAddress2),
              foreignMailingZipError: isEmptyOrSpaces(foreignMailingZip) || !isValidateZipLength(foreignMailingZip),
              foreignMailingAddressError: isEmptyOrSpaces(foreignMailingAddress),
              dropDownMailingCountryError: isEmptyOrSpaces(countryCode) || countryCode == "US"
            }) : _this.setState({
              mailingCityError: isEmptyOrSpaces(mailingCity),
              mailingZipError: isEmptyOrSpaces(mailingZip) || !isValidateZipLengthNew(mailingZip) || !checkForZip(mailingZip),
              mailingAddressError: isEmptyOrSpaces(mailingAddress),
              mailingStreetAddressError: isEmptyOrSpaces(mailingAddress),
              dropDownMailingStateError: isEmptyOrSpaces(mailingState)
            });
          }
        }
      }, translations.UpdateMailingAddress) : null)))));
    });
  };
  return ContactInformation;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch,
    updateProfile: function (profile) {
      return dispatch({
        type: IDS_USER_PROFILE,
        userProfile: profile
      });
    }
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(ContactInformation);